import { StyleSheet, Platform } from 'react-native';
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  scrollItemsContainer: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50,
  },
  headerSmall: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 10,
  },
  goBackContainerLarge: {
    flex: 0.1,
    alignSelf: 'center',
  },
  goBackContainerSmall: {
    alignSelf: 'center',
    flex: 0.3,
  },
  imageLarge: {
    alignSelf: 'center',
    marginLeft: 35,
    width: 23,
    height: 19,
  },
  imageSmall: {
    alignSelf: 'center',
    marginLeft: 10,
    width: 15,
    height: 12,
  },
  textTitleLarge: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-start',
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  textSmall: {
    marginLeft: '3%',
    alignSelf: 'center',
    justifyContent: 'center',
    color: '#001639',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  upperTextContainerLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    marginTop: 45,
    marginBottom1: 10,
  },
  textTitleLargeCommerce: {
    color: '#807F7F',
  },
  textTitleLargeBilling: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'flex-start',
    justifyContent: 'flex-start',
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'right',
    marginLeft: 23,
  },
  topRowForDescriptionOnListOrders: {
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    width: '90%',
    justifyContent: 'space-evenly',
    height: 60,
    paddingVertical: 20,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  topRowTextForDescription: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: 'center',
    color: '#FFFFFF',
  },
  textLarge: {
    flex: 0.5,
    marginLeft: '10%',
    color: '#fff',
    alignSelf: 'center',
    fontSize: 30,
    fontWeight: '700',
    marginRight: '20%',
  },
  iconLarge: {
    flex: 0.5,
    alignSelf: 'center',
    color: '#0F6657',
  },
  iconSmall: {
    flex: 0.3,
    alignSelf: 'flex-start',
    color: '#0F6657',
  },
  totalContainer: {
    height: 44,
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginRight: '17.1%',
    marginLeft: '2%',
    alignItems: 'center',
    paddingHorizontal: '13%',
    backgroundColor: 'white',
  },
  totalContainerLarge: {
    flex: 0.7,
    height: hp('19%'),
    width: wp('15%'),
    borderRadius: 10,
    flexDirection: 'row',
    alignSelf: 'center',
    marginLeft: '4%',
  },
  totalContainerSmall: {
    height: 150,
    width: '90%',
    borderRadius: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  totalTextContainerAdjustmentsLarge: {
    marginTop: 20,
    marginLeft: 35,
  },
  totalTextContainerAdjustmentsSmall: {
    justifyContent: 'center',
    alignSelf: 'center',
    paddingVertical: 30,
  },
  totalTextTitleLarge: {
    marginLeft: 15,
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
    marginBottom: 5,
  },
  totalTextTitleSmall: {
    marginTop: 10,
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
  },
  totalTextBalanceLarge: {
    marginTop: 15,
    fontSize: 36,
    fontWeight: '700',
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: 'left',
    marginBottom: 100,
  },
  totalTextBalanceSmail: {
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: 'center',
    marginBottom: 10,
  },
  cardsContainerLarge: {
    flex: 1,
    marginHorizontal: 30,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  cardsContainerSmall: {
    marginHorizontal: 30,
    marginTop: hp('5%'),
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  cardColumn: {
    flex: 1,
    marginHorizontal: 30,
  },
  billingResumeTitleLarge: {
    color: '#001639',
    fontWeight: '500',
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
  },
  billingResumeTitleSmall: {
    color: '#001639',
    fontSize: 12,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
  },
  billingResumeNumberLarge: {
    color: '#001639',
    fontSize: 36,
    fontWeight: '700',
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: 'center',
    marginVertical: 20,
  },
  billingResumeNumberSmall: {
    color: '#001639',
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: 'center',
    marginVertical: 15,
  },
  billingResumeContainerLarge: {
    paddingVertical: 20,
    width: wp('12%'),
    alignSelf: 'flex-start',
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
  billingResumeContainerSmall: {
    paddingVertical: 10,
    alignSelf: 'center',
    width: 150,
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
  productsContainerLarge: {
    flexDirection: 'column',
    marginBottom: '1%',
    alignSelf: 'center',
    width: '100%',
  },
  scrollProductsLarge: {
    justifyContent: 'center',
  },
  productsContainerSmall: {
    flexDirection: 'column',
    width: '100%',
    alignSelf: 'center',
  },
  productsInsideContainerLarge: {
    flex: 1,
    paddingTop: '2%',
    flexDirection: 'column',
  },
  productsInsideContainerSmall: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
  headerRowSmall: {
    alignSelf: 'center',
    marginBottom: '8%',
  },
  headerRowLarge: {
    alignSelf: 'center',
    marginBottom: '6%',
  },
  productsHeaderTextLarge: {
    fontWeight: 'bold',
    color: '#001C47',
    fontSize: 25,
  },
  productHeaderTextSmall: {
    fontWeight: 'bold',
    color: '#001C47',
    fontSize: 19,
  },
  productTextLarge: {
    color: '#001C47',
    fontWeight: '500',
    fontSize: 22,
  },
  productTextSmall: {
    color: '#001C47',
    fontWeight: '600',
    fontSize: 18,
    textAlign: 'center',
  },
  productNameSmall: {
    color: '#001C47',
    fontWeight: '600',
    fontSize: 18,
    paddingLeft: 5,
    textAlign: 'center',
  },
  rowLarge: {
    alignSelf: 'center',
    textAlign: 'center',
    paddingLeft: '5%',
    marginBottom: '6%',
  },
  rowSmall: {
    alignSelf: 'center',
    marginBottom: Platform.OS === 'web' ? '18%' : '12%',
    height: 60,
  },
});
